import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../components/Login.vue'
import Block from '../components/Block.vue'
import Folder from '../components/Folder.vue'
import FolderDetail from '../components/FolderDetail.vue'
import MapView from '../components/MapView.vue'
import MainPlant from "@/components/MainPlant";
import H2pMainPlant from "@/components/H2pFileMaker/H2pMainPlant";
import Data from "@/components/H2pFileMaker/Data";
import H2p from "@/components/H2pFileMaker/H2p";
import VideoDetail from "@/components/VideoDetail";
import ViewPosition from "@/components/H2pFileMaker/ViewPosition";
import ReportPrint from "@/components/dialog/ReportPrint";
import Pfs from "@/components/PfsFile/Pfs";
import PfsMainPlant from "../components/PfsFile/PfsMainPlant";
import PfsData from "../components/PfsFile/PfsData";
import DroneImagesReupload from "@/components/DroneImagesReupload";
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/plant',
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/plant',
    name: 'MainPlant',
    component: MainPlant,
  },
  {
    path: '/plant/:plantId/block',
    name: 'Block',
    component: Block,
  },
  {
    // path: '/block/:blockId/folder',
    path: '/plant/:plantId/folder',
    name: 'Folder',
    component: Folder,
  },
  {
    path: '/folder/:folderId',
    name: 'FolderDetail',
    component: FolderDetail,
  },
  {
    path: '/folder/reupload/:folderId',
    name: 'FolderReupload',
    component: DroneImagesReupload,
    props: true
  },
  {
    path: '/video/:folderId',
    name: 'VideoDetail',
    component: VideoDetail,
  },
  {
    path: '/map/:folderId',
    name: 'MapView',
    component: MapView,
    meta: {
      mapview: true,
    }
  },
  {
    path: '/report/:folderId',
    name: 'ReportPrint',
    component: ReportPrint,
  },
  {
    path: '/auth/:provider/callback',
    component: {
      template: '<div class="auth-component"></div>'
    },
  },
  //this is a router for h2p

  {
    path: '/h2p',
    component: H2p,
    children: [
      {
        path: '',
        component: H2pMainPlant,
      },
      {
        path: ':plantId/data',
        component: Data,
      },
      {
        path: ':folderId/position/:arrayPositionId',
        component: ViewPosition,
        meta: {
          h2pmapview: true,
        }
      }
    ]
  },

  {
    path: '/pfs',
    component: Pfs,
    children: [
      {
        path: '',
        component: PfsMainPlant,
      },
      {
        path: ':kikanId/polygon',
        component: PfsData,
      },
    ]
  }

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = [
    '/login',
    '/auth/google/callback',
  ];
  const authRequired = !(publicPages.includes(to.path));
  const loggedIn = localStorage.getItem('dfs_user');
  if (authRequired && !loggedIn) {
    return next({
      path: '/login',
      query: { nextUrl: to.path },
  })
  }
  next();
})

export default router
